class CancellableRequest {
  constructor(axiosInstance) {
    this.axios = axiosInstance
    this.abortControllers = {}
  }

  /**
   * This function will cancel any prior GET request when a new
   * one is issued. The benefit of this is that it allows us to
   * fire off requests on every route change but bail if another
   * route change happens before the original API call comes back.
   */
  get(path, { cancelKey, ...opts }) {
    const axiosOpts = { ...opts }

    if (cancelKey) {
      // Abort previous request with this key
      if (this.abortControllers[cancelKey]) {
        this.abortControllers[cancelKey].abort()
      }

      // Create a new AbortController for this request
      const controller = new AbortController()
      this.abortControllers[cancelKey] = controller

      // Pass the signal to axios
      axiosOpts.signal = controller.signal
    }

    return this.axios.get(path, axiosOpts).catch(error => {
      if (error.code === 'ERR_CANCELED' && error.message === 'canceled') {
        // noop, request was cancelled by subsequent request
      } else {
        throw error
      }
    })
  }
}

export default CancellableRequest
